/* DeptAllItems.js – shows *all* items for a category */
import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import './Departments.css';            // reuse same card styles

const cleanText = (txt = '') => txt.replace(/(https?:\/\/[^\s]+)/g, '').trim();
const urlRx     = /(https?:\/\/[^\s]+)/g;
const domainRx  = /^https?:\/\/121\.52\.154\.120:3001\//i;

const ItemCard = ({ x }) => (
  <div className="common-card" style={{ height: 'auto' }}>
    <img
      className="common-card-image"
      src={`http://121.52.154.120:3001${x.imageUrl}`}
      alt={x.title}
    />
    <div className="card-content">
      <h5 className="card-title">{x.title}</h5>
      <p className="card-description" style={{ WebkitLineClamp: 'unset', lineClamp: 'unset' }}>
        {cleanText(x.description)}
      </p>

      {/* attachments / links */}
      {(x.description || '').match(urlRx)?.map((u, i) => (
        <a
          key={i}
          href={u}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: 'inline-block', marginRight: 6 }}
        >
          {domainRx.test(u) ? 'Download' : 'See more details'}
        </a>
      ))}
    </div>
  </div>
);

export default function DeptAllItems() {
  const { id: deptId, type } = useParams();
  const [items, setItems]    = useState([]);

  useEffect(() => {
    const map = {
      research : 'dept-research',
      news     : 'dept-news-events',
      circulars: 'dept-circulars-info',
      sliders  : 'dept-sliders',
    };
    const endpoint = map[type] || '';
    if (!endpoint) return;

    axios
      .get(`http://121.52.154.120:3001/api/${endpoint}/${deptId}`)
      .then(({ data }) => setItems(Array.isArray(data) ? data.reverse() : []))
      .catch(() => setItems([]));
  }, [deptId, type]);

  return (
    <div className="page-container container">
      <h2 className="consultative-events-heading" style={{ marginTop: 20 }}>
        {type.replace(/^\w/, (c) => c.toUpperCase())} – All
      </h2>

      <Link to={`/department/${deptId}`} style={{ fontSize: 14 }}>
        ← Back to Department
      </Link>

      <div className="row" style={{ marginTop: 20 }}>
        {items.length === 0 && <p>No data available.</p>}
        {items.map((x) => (
          <div key={x.id} className="col-md-4 col-sm-6" style={{ marginBottom: 20 }}>
            <ItemCard x={x} />
          </div>
        ))}
      </div>
    </div>
  );
}
